import { CommonSetting } from './Common/CommonSettings';
import { InvoiceSetting } from './InvoiceSetting';
export class ApplicationConfiguration {
  CustomSettings: any;
  ProductSettings: any[];
  InvoiceSettings: InvoiceSetting[];
  Settings: CommonSetting[];
}
